import { Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CalendarBootstrap } from "../../../../Constant";
import { BOOTSTRAP_CALENDER } from "../../../../Data/FormWidgets";

const BootstrapCalendar = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={CalendarBootstrap} />
        <CardBody className="card-wrapper">
          {BOOTSTRAP_CALENDER.map((data:any) => (
            <Row className="mb-3" key={data.id}>
              <Col md="3">
                <Label className="col-form-label">{data.labelText}</Label>
              </Col>
              <Col md="9">
                <Input className="digits" type={data.type} defaultValue={data.value} />
              </Col>
            </Row>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default BootstrapCalendar;
